import React, { ComponentProps } from 'react';
import Link from 'next/link';
import classNames from 'classnames';

import styles from './Tab.module.css';

type TabProps = Pick<ComponentProps<typeof Link>, 'href'> & {
  isActive: boolean;
};

export default function Tab(
  {
    children,
    isActive = false,
    href,
  }: React.PropsWithChildren<TabProps>,
): React.ReactElement {
  return (
    <Link
      href={href}
      prefetch
      className={classNames(styles.tab, { [styles['tab--active']]: isActive })}
    >
      {children}
    </Link>
  );
}
